const CodeSnippetsParser = require('../CodeSnippetsParser/index');
const MenuUtils = require('../../../utils/menu');
const { sanitizePath } = require('../URLSanitizer');

const goToLocation = (contentContainer) => {
  const { hash: hashId } = window.location;
  if (hashId !== '') {
    const id = decodeURIComponent(hashId).replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView();
        window.scrollBy(0, -65);
      }, 500);
    }
    return;
  }
  if (contentContainer && contentContainer.current) {
    contentContainer.current.scrollIntoView();
    contentContainer.current.click();
  }
};

const onPageLoad = (contentContainer, setHtmlContent, setActiveItem, history, siteId, lang) => {
  // Avoid natural propagation of 'a' elements for use the SPA History for navigation
  if (contentContainer && contentContainer.current) {
    const iframeList = contentContainer.current.querySelectorAll('iframe[origin="dx-devsite-markdown"]');
    iframeList?.forEach(iframe => {
      if (iframe?.getAttribute('src-data')) {
        iframe?.setAttribute('src', iframe?.getAttribute('src-data'));
      }
    });

    const elementsSize = contentContainer.current.getElementsByTagName('a').length;
    for (let i = 0; i < elementsSize; i += 1) {
      const link = contentContainer.current.getElementsByTagName('a').item(i);
      link.pathname = link.pathname.replace(/\/\//, '/');

      const actualEndpoint = link.pathname;
      const actualDomain = window.location.hostname.split('.').pop();
      let addEvent = false;
      addEvent = actualEndpoint.match(/\/developers\/(es|pt|en)\/docs/);
      addEvent = addEvent && !link.hash;
      addEvent = addEvent && (actualDomain === link.hostname.split('.').pop());
      addEvent = addEvent && actualEndpoint.match(`/developers/${lang}/`);
      addEvent = addEvent && link.getAttribute('role') !== 'tab';
      /*
          Only on our 'paths', otherwise don't implement this.
          The '!link.hash' is to avoid the code snippets languange change.
          Verify the host is equal (when changes the country) - but not for the development.
          If the language is not equal (when changes de lang) should use the default's <a> behavior
          If is a Tab element, should not process as link
          */
      if (addEvent) {
        link.addEventListener('click', (e) => {
          const item = MenuUtils.getItemFromURL(sanitizePath(e.currentTarget.pathname), siteId, lang);
          if (!item) {
            return true;
          }
          if (e.currentTarget.pathname !== window.location.pathname) {
            setHtmlContent(null);
            setActiveItem(item);
            history.push(e.currentTarget.pathname);
          }
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        });
      }
    }
  }

  // Necessary for the code snippets work
  if (window && window.Prism) {
    window.Prism.highlightAll();
    CodeSnippetsParser();
    goToLocation(contentContainer);
  }
};

module.exports = { onPageLoad, goToLocation };
